import React, { Component } from "react";
import config from "lib/fr-config";
import { getDeviceType } from "lib/deviceInfo";
import CommonModalView from "presentational/common/modals/CommonModalView";
import TXT from "presentational/common/multinational/TXT";
import { getGradationCss } from "lib/commonUtil";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const itemColorList = config.itemColorList;

const CustomButton = withStyles({
  root: { padding: 0 }
})(Button);

const cssXL = {
  colorBlock: {
    height: 40,
    whiteSpace: "normal",
    lineHeight: 1.3,
    padding: "0 15px",
    fontSize: 14
  }
};
const cssXS = {
  colorBlock: {
    height: 34,
    whiteSpace: "normal",
    lineHeight: 1.3,
    padding: "0 10px",
    fontSize: 12
  }
};

class ColorSelectorModalView extends Component {
  static propTypes = {
    value: PropTypes.string,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired
  };

  handleColorBoxClick = color => () => {
    const { onSelect, onClose } = this.props;
    onSelect(color);
    onClose();
  };

  textColor(color) {
    const blackFontList = [
      "ivory",
      "yellow",
      "mint",
      "lightgreen",
      "skyblue",
      "khaki",
      "beige",
      "pink",
      "gray",
      "lavender",
      "orange",
      "white"
    ];
    const black = "#000000";
    const white = "#ffffff";

    for (let i = 0; i < blackFontList.length; i++) {
      if (color === blackFontList[i]) return black;
    }
    return white;
  }

  getStyleOfColorBlock(color) {
    const css = getDeviceType() === "mobile" ? cssXS : cssXL;

    return {
      ...css.colorBlock,
      background: getGradationCss(itemColorList[color]),
      color: `${this.textColor(color)}`
    };
  }

  colorBlockElement() {
    return (
      <Grid container spacing={1}>
        {Object.keys(itemColorList).map(value => (
          <Grid item xs={4} key={value}>
            <CustomButton
              variant="contained"
              fullWidth
              style={this.getStyleOfColorBlock(value)}
              onClick={this.handleColorBoxClick(value)}
            >
              <TXT textType="color" name={value} />
            </CustomButton>
          </Grid>
        ))}
      </Grid>
    );
  }

  render() {
    const { open, onClose } = this.props;

    return (
      <CommonModalView
        open={open}
        onClose={onClose}
        paperStyle={{ width: "100%" }}
        titleText={<TXT name="titleModal_color" />}
        contentComponent={this.colorBlockElement()}
        firstButtonText={<TXT name="btnModal_close" />}
        firstButtonFunc={onClose}
      />
    );
  }
}

export default ColorSelectorModalView;
